module.exports = __webpack_public_path__ + "static/media/netball.5ae55c91.svg";